import { apiClient } from './client';
import { Commit } from '../types';

export async function getCommits(
  workspace: string,
  branch?: string
): Promise<Commit[]> {
  const query = branch ? `?branch=${encodeURIComponent(branch)}` : '';
  return apiClient<Commit[]>(
    `/commits/${encodeURIComponent(workspace)}${query}`
  );
}

export async function getCommit(
  workspace: string,
  sha: string
): Promise<Commit> {
  return apiClient<Commit>(
    `/commits/${encodeURIComponent(workspace)}/commit/${sha}`
  );
}

export async function getDiff(
  workspace: string,
  sha1: string,
  sha2: string
): Promise<string> {
  return apiClient<string>(
    `/commits/${encodeURIComponent(workspace)}/diff/${sha1}/${sha2}`
  );
}

export async function revertToCommit(
  workspace: string,
  sha: string
): Promise<{ success: boolean; newCommitSha: string }> {
  return apiClient(
    `/commits/${encodeURIComponent(workspace)}/revert/${sha}`,
    {
      method: 'POST',
    }
  );
}

export async function getBranches(workspace: string): Promise<string[]> {
  return apiClient<string[]>(
    `/commits/${encodeURIComponent(workspace)}/branches`
  );
}

interface ConnectedRepo {
  id: string;
  name: string;
  fullName: string;
  url: string;
}

export async function getConnectedRepos(): Promise<ConnectedRepo[]> {
  return apiClient<ConnectedRepo[]>('/config/repos');
}

export async function connectRepo(repoFullName: string): Promise<ConnectedRepo> {
  return apiClient<ConnectedRepo>('/config/repos', {
    method: 'POST',
    body: { repoFullName },
  });
}

export async function disconnectRepo(id: string): Promise<void> {
  return apiClient(`/config/repos/${id}`, {
    method: 'DELETE',
  });
}
